export const customizationRoleOptions = [
  { label: "客户", value: "customer", color: "#d97706", bgColor: "#fffbeb" },
  { label: "销售", value: "sales", color: "#165dff", bgColor: "#e6f4ff" },
  { label: "专家", value: "expert", color: "#6366f1", bgColor: "#eef2ff" },
  { label: "计调", value: "dispatcher", color: "#722ed1", bgColor: "#f9f0ff" },
  { label: "导游", value: "guide", color: "#0891b2", bgColor: "#ecfeff" },
  { label: "学生", value: "student", color: "#16a34a", bgColor: "#f0fdf4" },
  { label: "老师", value: "teacher", color: "#a16207", bgColor: "#fefce8" },
] as const;

export const customizationSourceOptions = [
  { label: "电话", value: "phone", color: "#16a34a", bgColor: "#f0fdf4" },
  { label: "微信", value: "wechat", color: "#059669", bgColor: "#ecfdf5" },
  { label: "后台", value: "backend", color: "#475569", bgColor: "#f8fafc" },
  { label: "行程链接", value: "route_link", color: "#165dff", bgColor: "#e6f4ff" },
  { label: "学生渠道", value: "student_channel", color: "#0891b2", bgColor: "#ecfeff" },
  { label: "专家评审", value: "expert_review", color: "#722ed1", bgColor: "#f9f0ff" },
] as const;

export const customizationProjectCustomerTypeOptions = ["学院类定制", "社会类定制"] as const;

export const customizationProjectTripTypeOptions = [
  "研学",
  "写生",
  "考察",
  "写生+考察",
  "社会出行",
] as const;

export const customizationProjectSignTypeOptions = [
  "团队",
  "单订车",
  "单订房",
  "单订导游",
  "单订保险",
  "单订非遗",
  "单订企业",
  "单订非遗和企业",
] as const;

export const customizationProjectDealProgressOptions = ["输单", "50%", "80%", "赢单"] as const;

export const customizationProjectListStatusOptions = [
  { label: "草稿", value: "输单" },
  { label: "设计中", value: "50%" },
  { label: "已发布", value: "80%" },
  { label: "已确认", value: "赢单" },
] as const;

export const customizationProjectListSourceOptions = [
  { label: "销售录入", value: "manual" },
  { label: "学生渠道", value: "student_channel" },
  { label: "行程链接", value: "route_link" },
] as const;

export const customizationProjectListItineraryOptions = [
  { label: "有行程", value: "true" },
  { label: "无行程", value: "false" },
] as const;

export const customizationProjectListOpportunityBoundOptions = [
  { label: "已归商机", value: "true" },
  { label: "未归商机", value: "false" },
] as const;

export const customizationProjectListSignTypeOptions = [
  { label: "团队", value: "团队" },
  { label: "单订车", value: "单订车" },
  { label: "单订房", value: "单订房" },
  { label: "单订导游", value: "单订导游" },
  { label: "单订保险", value: "单订保险" },
  { label: "单订非遗", value: "单订非遗" },
  { label: "单订企业", value: "单订企业" },
  { label: "单订非遗和企业", value: "单订非遗和企业" },
] as const;

export const customizationProjectOperatingCompanyOptions = [
  "花儿旅行社",
  "旅文化",
  "红柳",
  "梭梭树",
  "蜀地",
  "行艺道美",
] as const;

export const customizationProjectListDefaultParams = {
  page: 1,
  pageSize: 20,
  scope: "mine" as const,
};

export const customizationProjectListPageSizeOptions = [10, 20, 50, 100].map((value) => ({
  label: `${value} 条`,
  value,
}));

export const customizationRoleLabels: Record<string, string> = Object.fromEntries(
  customizationRoleOptions.map((option) => [option.value, option.label]),
);

export const customizationRoleColors: Record<string, { color: string; bgColor: string }> =
  Object.fromEntries(
    customizationRoleOptions.map((option) => [
      option.value,
      { color: option.color, bgColor: option.bgColor },
    ]),
  );

export const customizationSourceLabels: Record<string, string> = Object.fromEntries(
  [
    ...customizationSourceOptions.map((option) => [option.value, option.label]),
    ["linked_itinerary", "关联行程"],
  ],
);

export const customizationSourceColors: Record<string, { color: string; bgColor: string }> =
  Object.fromEntries(
    customizationSourceOptions.map((option) => [
      option.value,
      { color: option.color, bgColor: option.bgColor },
    ]),
  );

export const customizationDealProgressColors: Record<string, { color: string; bgColor: string }> = {
  输单: { color: "#64748b", bgColor: "#f1f5f9" },
  "50%": { color: "#165dff", bgColor: "#e6f4ff" },
  "80%": { color: "#d97706", bgColor: "#fffbeb" },
  赢单: { color: "#16a34a", bgColor: "#f0fdf4" },
};

export const customizationTripTypeColors: Record<string, { color: string; bgColor: string }> = {
  研学: { color: "#165dff", bgColor: "#e6f4ff" },
  写生: { color: "#722ed1", bgColor: "#f9f0ff" },
  考察: { color: "#d97706", bgColor: "#fffbeb" },
  "写生+考察": { color: "#6366f1", bgColor: "#eef2ff" },
  社会出行: { color: "#475569", bgColor: "#f8fafc" },
};

export const customizationSignTypeColors: Record<string, { color: string; bgColor: string }> = {
  团队: { color: "#165dff", bgColor: "#e6f4ff" },
  单订车: { color: "#64748b", bgColor: "#f1f5f9" },
  单订房: { color: "#94a3b8", bgColor: "#f8fafc" },
  单订导游: { color: "#0891b2", bgColor: "#ecfeff" },
  单订保险: { color: "#059669", bgColor: "#ecfdf5" },
  单订非遗: { color: "#722ed1", bgColor: "#f9f0ff" },
  单订企业: { color: "#6366f1", bgColor: "#eef2ff" },
  "单订非遗和企业": { color: "#9333ea", bgColor: "#faf5ff" },
};

export const customizationStatusColors = {
  neutral: { color: "#475569", bgColor: "#f8fafc" },
  pending: { color: "#64748b", bgColor: "#f1f5f9" },
  missing: { color: "#dc2626", bgColor: "#fef2f2" },
  review: { color: "#dc2626", bgColor: "#fef2f2" },
  complete: { color: "#16a34a", bgColor: "#f0fdf4" },
} as const;

export const customizationDemandGroupLabels: Record<string, string> = {
  base: "基础信息",
  customer: "客户需求",
  teacher: "老师需求",
  service: "服务标准",
};

export const customizationDemandFieldLabels: Record<string, string> = {
  sourceTraceSummary: "追溯摘要",
  demandSummary: "需求摘要",
  destinationSummary: "目的地",
  provinces: "目的地省份",
  provinceNames: "目的地省份",
  primarySchoolNameSnapshot: "出发高校/组织",
  customerName: "客户",
  contactName: "客户联系人",
  majorNames: "所学专业",
  pointNames: "考察点",
  stayAreaNames: "目的地住宿点",
  durationDays: "行程天数",
  departureStartDate: "出发日期",
  totalCount: "总人数",
  studentCount: "学生人数",
  teacherCount: "老师人数",
  budgetPerPerson: "人均预算区间",
  customerType: "定制用户类型",
  tripType: "出行类型",
  signType: "签单类型",
  quoteMode: "报价方式",
  dealProgress: "成单进度",
  dispatcherUserName: "第一计调",
  operatingCompany: "操作公司",
  teachingRequirements: "教学要求",
  specialRequirements: "特殊需求",
  schoolPickupRequirement: "往返学校接送要求",
  invoiceRequirement: "发票要求",
  remark: "备注",
  teacherMealRequirement: "老师餐饮要求",
  teacherTicketRequirement: "老师门票要求",
  teacherTransportRequirement: "老师交通要求",
  teacherAccommodationRequirement: "老师住宿要求",
  guideCount: "领队/导游数",
  guideNote: "领队/导游要求",
  includeTickets: "是否含考察点门票",
  includeMeals: "全程是否含餐",
  roundTripTransportNote: "行程大交通工具",
  localTransportNote: "大巴车",
  accommodationNote: "团队住宿",
  companyVisitCount: "考察企业数",
  intangibleHeritageCount: "考察非遗数",
  ticketNote: "考察点门票要求",
  mealStandards: "团队餐饮类型",
  mealNote: "团队餐饮要求",
  companyVisitNote: "考察企业要求",
  intangibleHeritageNote: "考察非遗要求",
  serviceStandard: "服务标准",
};

export const customizationDemandLookupValueLabels: Record<string, Record<string, string>> = {
  customerType: {
    学院类定制: "学院类定制",
    社会类定制: "社会类定制",
  },
  tripType: {
    研学: "研学",
    写生: "写生",
    考察: "考察",
    "写生+考察": "写生+考察",
    社会出行: "社会出行",
  },
  signType: {
    团队: "团队",
    单订车: "单订车",
    单订房: "单订房",
    单订导游: "单订导游",
    单订保险: "单订保险",
    单订非遗: "单订非遗",
    单订企业: "单订企业",
    单订非遗和企业: "单订非遗和企业",
  },
  dealProgress: {
    输单: "输单",
    "50%": "50%",
    "80%": "80%",
    赢单: "赢单",
  },
  operatingCompany: {
    花儿旅行社: "花儿旅行社",
    旅文化: "旅文化",
    红柳: "红柳",
    梭梭树: "梭梭树",
    蜀地: "蜀地",
    行艺道美: "行艺道美",
  },
};
